import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TOKEN_KEY = "adg_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export function authHeaders() {
  const tk = getToken();
  return tk ? { Authorization: `Bearer ${tk}` } : {};
}

export const adminApi = {
  login: (username, password) => axios.post(`${API}/admin/login`, { username, password }),
  me: () => axios.get(`${API}/admin/me`, { headers: authHeaders() }),
  updateCredentials: (data) => axios.put(`${API}/admin/credentials`, data, { headers: authHeaders() }),

  reservations: () => axios.get(`${API}/admin/reservations`, { headers: authHeaders() }),
  setReservationStatus: (id, status) => axios.patch(`${API}/admin/reservations/${id}`, { status }, { headers: authHeaders() }),
  deleteReservation: (id) => axios.delete(`${API}/admin/reservations/${id}`, { headers: authHeaders() }),

  contacts: () => axios.get(`${API}/admin/contacts`, { headers: authHeaders() }),
  deleteContact: (id) => axios.delete(`${API}/admin/contacts/${id}`, { headers: authHeaders() }),

  menu: () => axios.get(`${API}/menu`),
  addMenuItem: (item) => axios.post(`${API}/admin/menu/items`, item, { headers: authHeaders() }),
  updateMenuItem: (id, item) => axios.put(`${API}/admin/menu/items/${id}`, item, { headers: authHeaders() }),
  deleteMenuItem: (id) => axios.delete(`${API}/admin/menu/items/${id}`, { headers: authHeaders() }),
  addCategory: (data) => axios.post(`${API}/admin/menu/categories`, data, { headers: authHeaders() }),
  updateCategory: (id, data) => axios.put(`${API}/admin/menu/categories/${id}`, data, { headers: authHeaders() }),
  deleteCategory: (id) => axios.delete(`${API}/admin/menu/categories/${id}`, { headers: authHeaders() }),

  gallery: () => axios.get(`${API}/gallery`),
  uploadGallery: (file, alt) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("alt", alt || "");
    return axios.post(`${API}/admin/gallery/upload`, fd, { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } });
  },
  addGalleryUrl: (url, alt) => axios.post(`${API}/admin/gallery/url`, { url, alt }, { headers: authHeaders() }),
  deleteGallery: (id) => axios.delete(`${API}/admin/gallery/${id}`, { headers: authHeaders() }),

  hours: () => axios.get(`${API}/hours`),
  updateHours: (hours) => axios.put(`${API}/admin/hours`, { hours }, { headers: authHeaders() }),

  backgrounds: () => axios.get(`${API}/backgrounds`),
  updateBackground: (section, data) => axios.put(`${API}/admin/backgrounds/${section}`, data, { headers: authHeaders() }),
  uploadBackground: (section, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/admin/backgrounds/${section}/upload`, fd, { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } });
  },

  services: () => axios.get(`${API}/services`),
  addService: (data) => axios.post(`${API}/admin/services`, data, { headers: authHeaders() }),
  updateService: (id, data) => axios.put(`${API}/admin/services/${id}`, data, { headers: authHeaders() }),
  deleteService: (id) => axios.delete(`${API}/admin/services/${id}`, { headers: authHeaders() }),

  aboutImages: () => axios.get(`${API}/about-images`),
  updateAboutImages: (data) => axios.put(`${API}/admin/about-images`, data, { headers: authHeaders() }),

  catering: () => axios.get(`${API}/catering`),
  updateCateringInfo: (data) => axios.put(`${API}/admin/catering/info`, data, { headers: authHeaders() }),
  addCateringItem: (data) => axios.post(`${API}/admin/catering/items`, data, { headers: authHeaders() }),
  updateCateringItem: (id, data) => axios.put(`${API}/admin/catering/items/${id}`, data, { headers: authHeaders() }),
  deleteCateringItem: (id) => axios.delete(`${API}/admin/catering/items/${id}`, { headers: authHeaders() }),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API}/admin/upload-image`, fd, { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } });
  },
};

export { API };